export const PRIZE_META = {
  pct10: { title: "10% OFF", sub: "your order", color: "#FF6F91" },
  pct15: { title: "15% OFF", sub: "your order", color: "#E8233F" },
  pct20: { title: "20% OFF", sub: "your order", color: "#7CC4FF" },
  bag: { title: "FREE BAG", sub: "surprise flavour, added to your order", color: "#7BD88F" },
  box12: { title: "FREE 12-PACK", sub: "jackpot! added to your next order", color: "#FFB21A" },
  // retired prizes, still shown for plays won before the change
  pct25: { title: "25% OFF", sub: "jackpot!", color: "#FFB21A" },
  pct5: { title: "5% OFF", sub: "your order", color: "#FFB21A" },
  ship: { title: "FREE SHIPPING", sub: "on any order", color: "#7CC4FF" },
};

// plays reset every day at midnight Atlantic time (matches the backend)
export const gameDay = () => new Intl.DateTimeFormat("en-CA", { timeZone: "America/Halifax" }).format(new Date());

export const deviceId = () => {
  let id = localStorage.getItem("sb-device");
  if (!id) {
    id = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);
    localStorage.setItem("sb-device", id);
  }
  return id;
};

export const GAME_SEEN = "sb-game-seen";
export const GAME_RESULT = "sb-game-result";
